
const AboutUsComponent = ({ data }) => {
    return (
        <div className="uploadbannerblmdiv">
            <div className="uploadbannerdivnewmain">
                <div className="consttactdetatlsarroedyrdiv">
                    <p className="cinnattddttdtsttspo">About Us</p>
                </div>
                <div className="abttsrtxtdivvnappadin">
                    <p className="abttsbttetxtttpp" style={{ whiteSpace: 'pre-wrap' }}>{data?.aboutBusiness || ""}</p>
                </div>
            </div>
        </div>
    );
}
export default AboutUsComponent;